import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Row,
  Col,
  Input,
  Tooltip,
  Select,
  Modal,
  Divider,
  Card,
  Typography,
  Popconfirm,
  DatePicker,
  Drawer,
} from "antd";
import dayjs from "dayjs";
import { EyeOutlined, CaretRightOutlined } from "@ant-design/icons";
import { useAdminReport } from "../../Hooks/Admin/useReport";
import { useDispatch } from "react-redux";
import { useAdminInvoices } from "../../Hooks/Admin/useInvoices";

const { Text } = Typography;

const Index = () => {
  const dispatch = useDispatch();
  const { getReports } = useAdminReport();
  const { getAllUser } = useAdminInvoices();

  const [selectedMonth, setselectedMonth] = React.useState("");
  const [selectedYear, setselectedYear] = React.useState(dayjs().format("YYYY"));
  useEffect(() => {
    get_report_data();
  }, [selectedMonth, selectedYear]);

  React.useEffect(() => {
    get_all_users();
  }, []);

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const [userList, setuserList] = React.useState([]);
  const [selectedUser, setselectedUser] = React.useState({});

  const get_all_users = async () => {
    try {
      const data = await getAllUser(dispatch);
      if (data.length > 0) {
        const arr = [];
        data.map((item) => {
          arr.push({ label: item.name, value: item.id });
        });
        setuserList(arr);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [tableData, settableData] = React.useState([]);

  const get_report_data = async () => {
    try {
      const vacationArr = [];
      const data = await getReports(
        {
          month: selectedMonth,
          year: selectedYear,
        },
        dispatch
      );
      console.log(data.data);
      if (data.data.length > 0) {
        data.data.map((item) => {
          let total =
            item.all_vacation.length > 0
              ? item.all_vacation.reduce((sum, vacation) => {
                  return (
                    sum +
                    (vacation.type === "full"
                      ? 1
                      : vacation.type === "half"
                      ? 0.5
                      : 0)
                  );
                }, 0)
              : 0;
          vacationArr.push({
            key: item.user_id,
            all_vacation: item.all_vacation,
            total: total,
            user_id: item.user_id,
          });
        });

        const sortedvacation = [...vacationArr].sort(
          (a, b) => b.total - a.total
        );
        settableData(sortedvacation);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const vacationColumns = [
    {
      title: "Name",
      dataIndex: "user_id",
      key: "user_id",
      align: "center",
      render: (text, record) => {
        return (
          <div>{userList.filter((item) => item.value === text)[0]?.label}</div>
        );
      },
    },
    {
      title: "Total Vacation Days",
      dataIndex: "total",
      key: "total",
      align: "center",
      render: (text, record) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (text, record) => {
        return (
          <div>
            <Tooltip title="View">
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  console.log(record);
                  setselectedUser(record);
                  showDrawer();
                }}
              >
                <CaretRightOutlined />
              </div>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const expandColumns = [
    {
      title: "Date",
      dataIndex: "vacation_date",
      key: "vacation_date",
      align: "center",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      align: "center",
      render: (text, record) => {
        return (
          <div>
            {record.type === "full"
              ? "Full"
              : record.type === "half"
              ? "Half"
              : ""}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Row style={{ marginBottom: "20px" }} gutter={[16, 24]}>
        <Col span={6}>
          <Select
            size="large"
            style={{ width: "100%" }}
            placeholder="Select Months"
            defaultValue={""}
            onChange={(e) => {
              setselectedMonth(e);
            }}
            options={[
              { value: "", label: "All Months" },
              { value: "1", label: "January" },
              { value: "2", label: "February" },
              { value: "3", label: "March" },
              { value: "4", label: "April" },
              { value: "5", label: "May" },
              { value: "6", label: "June" },
              { value: "7", label: "July" },
              { value: "8", label: "August" },
              { value: "9", label: "September" },
              { value: "10", label: "October" },
              { value: "11", label: "November" },
              { value: "12", label: "December" },
            ]}
          ></Select>
        </Col>
        <Col span={6}>
          <DatePicker
            style={{ width: "100%" }}
            size="large"
            maxDate={dayjs()}
            defaultValue={dayjs()}
            format={"YYYY"}
            onChange={(date, dateString) => {
              setselectedYear(dateString);
            }}
            picker="year"
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #f0f0f0",
              padding: "0 10px",
              borderRadius: "5px",
            }}
          >
            <h3>Vacation</h3>
          </div>
          <Table
            columns={vacationColumns}
            dataSource={tableData}
            pagination={false}
          />
        </Col>
      </Row>
      <Drawer
        width={"35%"}
        title={
          userList.filter((item) => item.value === selectedUser?.user_id)[0]
            ?.label + " Vacation"
        }
        onClose={onClose}
        open={open}
      >
        <Table
          columns={expandColumns}
          dataSource={selectedUser?.all_vacation}
          pagination={false}
        />
      </Drawer>
    </div>
  );
};

export default Index;
